export const DATE_FORMAT = "DD-MM-YYYY";
export const DATE_FORMAT_EXP = "YYYY-MM-DD";
export const MAX_NOMBRES = 30;
export const MAX_CURP = 18;
export const MAX_RFC = 13;
export const MAX_CLAVE_FUAR = 18;
export const MAX_CALLE = 80;
export const MAX_COLONIA = 50;
export const NIV_SUPERIOR = "9";
// export const REGEX_RFC = /^[A-Z]{3,4}[0-9]{6}([A-Z0-9]{3})*$/i;
export const REGEX_RFC = /^([A-Z]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})*$/i;
export const REGEX_CURP =  /^[A-Z]{4}[0-9]{6}[H|M][A-Z]{5}[A-Z0-9][0-9]$/i;
export const REGEX_CLAVE = /^([A-Z]{5,6}\d{8}[H|M]\d{3})$|^([0-9]{13})$/i;


export const FECHA_LIM_REGISTRO = 10;
export const AVISO_PRIVACIDAD = 11;
export const TITULO_AVISO_PRIVACIDAD = 12;
export const MODO_PRUEBAS = 20;
export const FECHA_EXPEDIENTE = 67;
export const BASE64 = "data:application/pdf;base64";

